export default "__VITE_ASSET__vwtzpUnF__"